// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"630":"code_activation-CodeActivationModal","777":"code_activation-PhoneVerification"}[chunkId] + "." + {"630":"80c7a5fb803f6ad2e407","777":"e58e9e2ccb24611300cf"}[chunkId] + ".js";
};